export function selectBase(state) {
  return state.bootstrap
}
